import React, { useMemo } from 'react';
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { useTextResources } from '../../../language';

const ReasonTypesDropDown = ({ reasonTypes = [], ...props }) => {
  const text = useTextResources();

  const data = useMemo(() => {
    return reasonTypes.map((type) => ({
      text: text(type.Name),
      value: type.Id,
    }));
  }, [reasonTypes]);

  return (
    <DropDown textField='text' valueField='value' data={data} {...props} />
  );
};

ReasonTypesDropDown.propTypes = {
  reasonTypes: PropTypes.array.isRequired,
}


export default ReasonTypesDropDown;
